// This file is generated by a script. Do not edit this file directly.
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }
  return twMerge(clsx(inputs));
}
export function ensureUnreachable(value, message) {
  throw new Error(message !== null && message !== void 0 ? message : "Unreachable code hit with value ".concat(String(value)));
}
